module.exports = __webpack_public_path__ + "/images/ico-e-commerce-2.8139241.svg";